import React from "react";
import { withRouter } from "react-router";
import { ELPSorters } from "../helpers/constants";
const getUrlSavedSorter = (location) => ELPSorters.find(s => s.get("value") === location.query.sort);
const withUrlSortParam = (WrappedComponent) => {
    class WrappedComponentWithUrlSortParam extends React.Component {
        render() {
            const selectedSorter = getUrlSavedSorter(this.props.location);
            const sortValue = selectedSorter && selectedSorter.get("value");
            return <WrappedComponent {...this.props} selectedSorter={selectedSorter} sortValue={sortValue}/>;
        }
    }
    return withRouter(WrappedComponentWithUrlSortParam);
};
export default withUrlSortParam;
